import { render, staticRenderFns } from "./CookieConsent.vue?vue&type=template&id=1187e099&scoped=true&"
import script from "./CookieConsent.vue?vue&type=script&lang=ts&"
export * from "./CookieConsent.vue?vue&type=script&lang=ts&"
import style0 from "./CookieConsent.vue?vue&type=style&index=0&id=1187e099&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1187e099",
  null
  
)

/* custom blocks */
import block0 from "./CookieConsent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports